import React from 'react';
import './damdupat.css';

const DamdupatThev = () => {
  return (
    <div className="damdupat-container">

      <div className="banner">
        <img src="/images/slider1.jpg" alt="Banner" />
      </div>

      <div className="apply-btn">
        <button>आताच अप्लाय करा ➤</button>
      </div>


      <h1>दाम दुप्पट ठेव योजना</h1>
      <p>
        आपण केलेल्या कष्टांचा फायदा तर आपल्याला होतोच. पण दुप्पट फायदा??? विश्वास नाही बसत ना? काहीतरी गडबड आहे असच वाटते.
        पण जर, योग्य नियोजन करून बनवलेल्या 'दाम दुप्पट योजनेमध्ये' पैसे गुंतवले तर मात्र आपल्या कष्टाची कमाई दुप्पट होऊन मिळणे नक्कीच शक्य होते.
      </p>

      <p><strong>5000 रुपयेचा गोल्डन बॉण्ड घ्या – 76 महिन्यानंतर दहा हजार रुपये मिळवा.</strong></p>

      <p>
        संस्थेच्या <strong>श्री वरद विनायक गोल्डन बॉण्ड योजनेत</strong> सहभागी होऊन जिंका सोन्याची नाणी व इतर विविध आकर्षक बक्षिसे.
      </p>

    <div class="container">
  <div class="column">
    <h1>आवश्यक कागदपत्रे :</h1>
    <ul>
        <li>पॅनकार्ड</li>
        <li>आधारकार्ड</li>
        <li>३ फोटो</li>
      </ul>
  </div>

  <div class="column">
    <h1>व्याजदर:</h1>
    <ul>
        <li>सेव्हिंग ठेवीवर व्याजदर - 6% प्रति वर्ष</li>
        <li>⁠पिग्मी ठेवीवर व्याजदर - 6% प्रति वर्ष</li>
      </ul>
  </div>
</div>
    </div>
  );
};

export default DamdupatThev;
